export interface JwtToken {
    oid: string,
    name?: string,
    unique_name?: string,
    appid?: string,
    scp?: string,
    roles?: string[],
}